<div class="container-fluid disconnected-container d-flex flex-column">

  <div class="row disconnected-header justify-content-center align-items-center">
    <div class="col-12 text-center">
      <img src="assets/logo_qwintal.svg" alt="Logo" class="logo">
    </div>
  </div>


  <!-- Contenu principal -->
  <div class="row flex-grow-1 disconnected-main">

    <!-- Colonne droite -->
    <div class="col-12 col-md-12 d-flex justify-content-center align-items-center">
      @if (hash) {
        <div class="w-100 p-4" style="max-width: 400px;">
          <form [formGroup]="passwordForm">
            <div class="mb-3 justify-content-center align-items-center welcome-text">
              <h2>Bienvenue</h2>
              <h3>Vous êtes maintenant inscrit sur Qwintal.<br/>
              Pour accéder à votre compte, veuillez définir votre mot de passe, ci-dessous</h3>
            </div>
            <div class="mb-3 d-flex justify-content-center align-items-center">
              <nb-form-field>
                <input [type]="inputType" nbInput fullWidth shape="round" class="input-login" placeholder="Nouveau mot de passe"
                  formControlName="password">
                <button nbSuffix nbButton ghost (click)="toggleShowPassword()">
                  <nb-icon [icon]="(inputType == 'password') ? 'eye-outline' : 'eye-off-2-outline'">
                  </nb-icon>
                </button>
              </nb-form-field>
            </div>
            <div class="mb-3 d-flex justify-content-center align-items-center">
              <nb-form-field>
                <input [type]="inputType" nbInput fullWidth shape="round" class="input-login"  placeholder="Confirmation"
                  formControlName="passwordConfirm" />
                <button nbSuffix nbButton ghost (click)="toggleShowPassword()">
                  <nb-icon [icon]="(inputType == 'password') ? 'eye-outline' : 'eye-off-2-outline'">
                  </nb-icon>
                </button>
              </nb-form-field>
            </div>
            <div class="mb-2 d-flex justify-content-center align-items-center">
              @if (error == 1) {
                <p class="error">Les mot de passe ne concordent pas</p>
              }
              @if (error == 2) {
                <p class="error">Ce lien à expiré.</p>
              }
            </div>
            <div class="form-group d-flex justify-content-center align-items-center">
              <button nbButton status="danger" shape="round" size="medium" class="submit-disconnect" [disabled]="!passwordForm.valid || loading"
              (click)="saveAction()" title="Enregistrer">Enregistrer</button>
            </div>
            <div class="form-group d-flex justify-content-center align-items-center">
              <a [routerLink]="['/auth']">Retour</a>
            </div>
          </form>
        </div>
      }
    </div>
  </div>

  <!-- Footer -->
  <div class="row disconnected-footer justify-content-center align-items-center">
    <div class="col-12 text-center">
      Visitez notre site <a href="https://www.qwintal.com" target="_blank">www.qwintal.fr</a>
    </div>
  </div>
</div>
